export default (path) => {
  if (path.substring(0, 1) === '/') {
    path = path.substring(1)
  }

  var base = process.env.APP_BASE
  if (base !== '/') {
    return process.env.APP_BASE + '/' + path
  } else {
    return '/' + path
  }
}



// WEBPACK FOOTER //
// ./src/api/urlHelper.js